import { CatalogNodeActions, CatalogNodeGetters, CatalogNodeMutations, CatalogNodeState } from "@medapro-types/ContentEditor/content-editor-store";
import { createNamespacedHelpers } from "vuex-composition-helpers";

const { useState, useActions, useGetters, useMutations } = createNamespacedHelpers<
  CatalogNodeState,
  CatalogNodeGetters,
  CatalogNodeActions,
  CatalogNodeMutations
>("contentEditor/catalogNode");

export function useCatalogNodeState() {
  return useState([
    "masterData",
    "path",
    "attributes",
    "mediaAssets",
    "metadata",
    "translatedMasterdata",
    "translatedAttributes",
    "translatedMediaAssets",
    "modified",
    "updateTasks",
    "updateErrors"
  ]);
}

export const useCatalogNodeGetters = () => {
  return useGetters(["isSaving", "hasUnsavedData", "lastRunSuccess"]);
};

export const useCatalogNodeMutations = () => {
  return useMutations([
    "refresh-masterdata",
    "setCatalogNodePath",
    "refresh-attributedata",
    "refresh-catalog-node-media-assets",
    "change-node",
    "update-loading-state",
    "update-save-status",
    "notification-seen",
    "mark-dirty-status",
    "clear-dirty-status",
    "reset-state",
    "reset-update-status",
    "load-translation-masterdata",
    "load-translation-attributes",
    "load-translation-mediaAssets"
  ]);
};

export const useCatalogNodeActions = () => {
  return useActions([
    "loadMasterData",
    "loadAttributeData",
    "loadMediaAssets",
    "loadCatalogGroupWithLocalizations",
    "loadTranslatedCatalogGroupLocalization",
    "loadTranslatedMasterData",
    "loadTranslatedAttributes",
    "loadTranslatedMediaAssets",
    "saveMasterData",
    "saveCatalogNodeAttributes",
    "saveMediaAssets",
    "SaveTranslatedMasterdata",
    "SaveTranslatedAttributes",
    "SaveTranslatedMediaAssets"
  ]);
};
